import account from './account'
import webhook from './webhook'
import conversion from './conversion'

export default {
  ...account,
  ...webhook,
  ...conversion,
}
